import {
  customInstance
} from "./chunk-PXAHF6KP.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// generated/search-bff/controllers/autosuggestion-admin/autosuggestion-admin.ts
var addCustomPlace = (addCustomPlaceGoogleRequest, options) => {
  return customInstance(
    {
      url: `/api/v1/autosuggestion/data/custom-places/google`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addCustomPlaceGoogleRequest
    },
    options
  );
};
var addCustomPlace1 = (addCustomPlaceEvRequest, options) => {
  return customInstance(
    {
      url: `/api/v1/autosuggestion/data/custom-places/ev`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addCustomPlaceEvRequest
    },
    options
  );
};
var addCustomPlaceBlacklistEntry = (addCustomPlaceBlacklistRequest, options) => {
  return customInstance(
    {
      url: `/api/v1/autosuggestion/data/custom-places/blacklist`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addCustomPlaceBlacklistRequest
    },
    options
  );
};
var getCustomPlaces = (params, options) => {
  return customInstance(
    {
      url: `/api/v1/autosuggestion/data/custom-places`,
      method: "GET",
      params
    },
    options
  );
};
var deleteCustomPlace = (placeId, options) => {
  return customInstance(
    {
      url: `/api/v1/autosuggestion/data/custom-places/${placeId}`,
      method: "DELETE"
    },
    options
  );
};
var deleteCustomPlaceBlacklistEntry = (placeId, options) => {
  return customInstance(
    {
      url: `/api/v1/autosuggestion/data/custom-places/blacklist/${placeId}`,
      method: "DELETE"
    },
    options
  );
};

// src/services/customPlaces/customPlaces.ts
async function getCustomPlaces2(params, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "getCustomPlaces");
    const data = await getCustomPlaces(params, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
async function addCustomPlace2(payload, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "addCustomPlace");
    const data = await addCustomPlace(payload, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
async function addCustomPlaceEv(payload, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "addCustomPlaceEv");
    const data = await addCustomPlace1(payload, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
async function addCustomPlaceBlacklistEntry2(payload, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "addCustomPlaceBlacklistEntry");
    const data = await addCustomPlaceBlacklistEntry(payload, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
async function deleteCustomPlace2(placeId, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "deleteCustomPlace");
    const data = await deleteCustomPlace(placeId, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
async function deleteCustomPlaceBlacklistEntry2(placeId, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "deleteCustomPlaceBlacklistEntry");
    const data = await deleteCustomPlaceBlacklistEntry(placeId, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getCustomPlaces2 as getCustomPlaces,
  addCustomPlace2 as addCustomPlace,
  addCustomPlaceEv,
  addCustomPlaceBlacklistEntry2 as addCustomPlaceBlacklistEntry,
  deleteCustomPlace2 as deleteCustomPlace,
  deleteCustomPlaceBlacklistEntry2 as deleteCustomPlaceBlacklistEntry
};
